import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { SupportedSeverityLabels } from 'src/app/models/tableColumns/supportedSeverityLabels.enum';
import { Severity } from 'src/app/models/api/governance/violationRule.model';
import { SeverityBarsComponent } from '../severity-bars/severity-bars.component';
import { NgClass } from '@angular/common';
import { BeautifyDisplayStringPipe } from 'src/app/pipes/beautify-display-string/beautify-display-string.pipe';

@Component({
  selector: 'app-severity-label',
  templateUrl: './severity-label.component.html',
  styleUrls: ['./severity-label.component.scss'],
  standalone: true,
  imports: [SeverityBarsComponent, NgClass, BeautifyDisplayStringPipe],
})
export class SeverityLabelComponent implements OnInit, OnChanges {
  @Input() public severity: Severity | string;
  @Input() public smallSize?: boolean;
  @Input() public wideSize?: boolean;

  public supportedSeverityLabels = SupportedSeverityLabels;
  public supportedSeverity: SupportedSeverityLabels;

  ngOnInit(): void {
    this._parseReceivedEnumToSupportedOne();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['severity'] && !changes['severity'].firstChange) {
      this._parseReceivedEnumToSupportedOne();
    }
  }

  private _parseReceivedEnumToSupportedOne() {
    const enumEntry = new Map(Object.entries(SupportedSeverityLabels)).get(this.severity) as SupportedSeverityLabels;

    if (!enumEntry) {
      throw new Error(
        `SeverityLabelComponent parseReceivedEnumToSupportedOne: Value ${this.severity} is not supported in the SupportedSeverityLabels`
      );
    }

    this.supportedSeverity = enumEntry;
  }
}
